<h2 mat-dialog-title>Your Discord Account</h2>
<mat-dialog-content>
    <p>
        You are signing in with the following Discord account:<br>
        <b>{{data.user.connections.discord?.username}}</b><br><br>
        To change your Discord account, please <a href="https://discord.gg/cult-of-jar" target="_blank">contact support</a>.
    </p>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>